"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: User
/**
 * User icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const User: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M5 20V19C5 15.134 8.13401 12 12 12V12C15.866 12 19 15.134 19 19V20" ></path>
            <path d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" ></path>
        </svg>
    );
};

User.displayName = "User";
